import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  FilterState,
  PropertySpaceFilterState,
  PropertySpaceRange,
  RangeSliderOption,
} from '@immosky/types';
import {
  isPropertySpaceFilterActive,
  selectFilterState,
} from '@immosky/object-search-filter';

@Component({
  selector: 'lib-property-space-filter',
  templateUrl: './property-space-filter.component.html',
  styleUrls: ['./property-space-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertySpaceFilterComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  options: RangeSliderOption[] = [];
  currentFilter!: PropertySpaceRange;
  propertySpaceFilterState!: PropertySpaceFilterState;

  @Output()
  update = new EventEmitter<PropertySpaceRange>();

  get canReset(): boolean {
    return isPropertySpaceFilterActive(
      this.currentFilter,
      this.propertySpaceFilterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    const subscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.propertySpaceFilterState = filterState.propertySpace;
        this.currentFilter = {
          ...this.propertySpaceFilterState.filter,
        };
        this.options = this.propertySpaceFilterState.options;
        this.cdRef.markForCheck();
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  reset() {
    this.currentFilter.min = this.options[0];
    this.currentFilter.max = this.options[this.options.length - 1];
    this.emitChange();
  }

  selectMin(option: RangeSliderOption) {
    this.currentFilter.min = option;
    this.emitChange();
  }

  selectMax(option: RangeSliderOption) {
    this.currentFilter.max = option;
    this.emitChange();
  }

  emitChange() {
    this.update.emit(this.currentFilter);
  }
}
